import axiosInstance from './services/axiosInstance'; // Import axios instance
import { API_CONFIG } from './config/config';

export const signupUser = async (userData) => {
  try {
    const response = await axiosInstance.post(`${API_CONFIG.AUTH_PATH}/signup`, userData);
    return { success: true, ...response.data };
  } catch (error) {
    return {
      success: false,
      message: error.response?.data?.message || error.message,
    };
  }
};

export const verifyOtp = async (email, otp) => {
  try {
    const response = await axiosInstance.post(`${API_CONFIG.AUTH_PATH}/verify-otp`, { email, otp });
    return { success: true, ...response.data };
  } catch (error) {
    return {
      success: false,
      message: error.response?.data?.message || error.message,
    };
  }
};

export const loginUser = async (email, password) => {
  try {
    const response = await axiosInstance.post(`${API_CONFIG.AUTH_PATH}/login`, { email, password });
    return {
      success: true,
      message: response.data.message,
      token: response.data.token,
      user: response.data.user, // Include user object from response
    };
  } catch (error) {
    return {
      success: false,
      message: error.response?.data?.message || error.message,
    };
  }
};